import { Suspense, useEffect, useState } from "react";
import SideMenu from "../dashboard/sideMenu";
import { AddOutlined } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import SubscriptionCard from "./subscriptionCard";
import { Card, Carousel, Button, Typography } from "antd";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import SubscriptionTabs from "./SubscriptionTabs";
import config from "../../config";
import { useSelector } from "react-redux";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import moment from "moment";
import Loader from "../loader";
import { useAccess } from "../../provider/AccessProvider";

export default function Subscription() {
  const navigate = useNavigate();
  const shopId = useSelector((state) => state.shopDetails.shopId);
  const [subscriptionList, setSubScriptionList] = useState([]);
  const [activeOrders, setActiveOrders] = useState([]);
  const [cancelledOrders, setCancelledOrders] = useState([]);
  const [expiredOrder, setExpiredOrder] = useState([]);
  const currentDate = moment().format("YYYY-MM-DD");
  const access = useAccess([
    "createSubscription",
    "editSubscription",
    "deleteSubscription",
    "cancelSubscription",
  ]);

  const [loading, setLoading] = useState(true);
  const fetchSubscription = async (shopId) => {
    var res = await fetch(
      `${config.newApiGateway}/subscription/fetchSubscription`,
      {
        method: "POST",
        headers: {
          "x-api-key": `${config.newApiKey}`,
          "Content-type": "application/json",
        },
        body: JSON.stringify({
          shopId,
          from: "",
        }),
      }
    );
    res = await res.json();
    console.log(res);
    setLoading(false);
    if (res.code === "ERROR") {
      return alert(res.message);
    }
    setSubScriptionList(res.subscriptions);
  };
  const fetchSubscriptionOrder = async (shopId) => {
    var res = await fetch(
      `${config.newApiGateway}/subscription/fetchSubscription`,
      {
        method: "POST",
        headers: {
          "x-api-key": `${config.newApiKey}`,
          "Content-type": "application/json",
        },
        body: JSON.stringify({
          shopId,
          from: "orders",
        }),
      }
    );
    res = await res.json();
    console.log(res);
    setLoading(false);
    if (res.code === "ERROR") {
      return alert(res.message);
    }
    var active = [];
    var cancelled = [];
    const expired = [];
    const subscriptionOrders = res.data;
    subscriptionOrders.forEach((data) => {
      if (
        (data.subscriptionStatus === "active" ||
          data.subscriptionStatus === "paused") &&
        !moment(data.subscriptionEndDate).isBefore(currentDate, "day")
      ) {
        active.push(data);
      }
      if (data.subscriptionStatus === "cancelled") {
        cancelled.push(data);
      }
      if (
        moment(data.subscriptionEndDate).isBefore(currentDate, "day") &&
        data.subscriptionStatus !== "cancelled"
      ) {
        expired.push(data);
      }
    });
    console.log("active22", active);
    setActiveOrders(active);
    setCancelledOrders(cancelled);
    setExpiredOrder(expired);
  };
  useEffect(() => {
    if (shopId) {
      fetchSubscription(shopId);
      fetchSubscriptionOrder(shopId);
    }
  }, [shopId]);

  console.log("activeOrders", activeOrders);

  const changeSubscriptionStatus = async (status, billId) => {
    console.log("Sub Status", status, billId);
    try {
      var res = await fetch(
        `${config.newApiGateway}/subscription/changeSubscriptionStatus`,
        {
          method: "POST",
          headers: {
            "x-api-key": `${config.newApiKey}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            billId: billId,
            status: status,
            updatedBy: "shopOwner",
          }),
        }
      );
      res = await res.json();
      console.log(res);
      if (res.code === "ERROR") {
        return alert(res.message);
      }
      if (res.code === "SUCCESS") {
        fetchSubscriptionOrder(shopId);
        return alert(res.message);
      }
    } catch (err) {
      console.log("Err");
    }
  };

  const PrevArrow = ({ onClick, className }) => {
    return (
      <button
        style={{
          position: "absolute",
          left: "-11px",
          top: "50%",
          border: "1px solid",
          background: "transparent",
          borderRadius: "50%",
          width: 35,
          height: 35,
          zIndex: 1,
          transform: "translateY(-50%)",
          cursor: className.includes("slick-disabled")
            ? "not-allowed"
            : "pointer",
        }}
        onClick={onClick}
      >
        <LeftOutlined
          style={{
            verticalAlign: "initial",
          }}
        />
      </button>
    );
  };
  const NextArrow = ({ onClick, className }) => {
    return (
      <button
        style={{
          position: "absolute",
          right: "11px",
          top: "50%",
          border: "1px solid",
          background: "transparent",
          borderRadius: "50%",
          width: 35,
          height: 35,
          zIndex: 1,
          transform: "translateY(-50%)",
          cursor: className.includes("slick-disabled")
            ? "not-allowed"
            : "pointer",
        }}
        onClick={onClick}
      >
        <RightOutlined
          alt="Left Arrow"
          style={{
            verticalAlign: "initial",
          }}
        />
      </button>
    );
  };

  return (
    <>
      <div>
        {loading && (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: "100vh",
            }}
          >
            <Loader size={56} />
          </Box>
        )}
        {!loading && (
          <Suspense fallback={<div>Loading...</div>}>
            <Card
              bodyStyle={{
                textAlign: "right",
              }}
              style={{
                marginBottom: "20px",
              }}
            >
              <Button
                type="primary"
                onClick={() => {
                  if (!access.createSubscription()) {
                    return;
                  }
                  navigate("/dashboard/subscription/create", {
                    state: {
                      mode: "create",
                    },
                  });
                }}
              >
                + Create
              </Button>
            </Card>
            <dl>
              <Typography.Title level={5}>Plans</Typography.Title>
              {subscriptionList.length > 0 ? (
                <Carousel
                  nextArrow={<NextArrow />}
                  prevArrow={<PrevArrow />}
                  slidesToShow={4}
                  arrows={true}
                  dots={false}
                  infinite={false}
                  style={{
                    boxShadow: "0 20px 27px rgb(0 0 0 / 5%)",
                  }}
                >
                  {subscriptionList.map((item, index) => {
                    return (
                      <div>
                        <SubscriptionCard
                          setSubScriptionList={setSubScriptionList}
                          key={index}
                          item={item}
                        />
                      </div>
                    );
                  })}
                </Carousel>
              ) : (
                <dd>No subscription plans found</dd>
              )}

              <Typography.Title level={5}>
                Current Subscriptions
              </Typography.Title>
              <SubscriptionTabs
                activeSubscriptions={activeOrders}
                cancelledSubscriptions={cancelledOrders}
                expiredSubscriptions={expiredOrder}
                subscriptionStatus={changeSubscriptionStatus}
              />
            </dl>
          </Suspense>
        )}
      </div>
    </>
  );
}
